import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';
import { VitotrolName } from '@vi-iot/client/index';

@Pipe({
  name: 'moduleIdRemover',
})
export class ModuleIdRemoverPipe implements PipeTransform {
  readonly vitotrolContext = 'Vitotrol';

  transform(value: string): string {
    if (typeof value !== 'string') {
      return NO_VALUE;
    }

    if (value.includes(this.vitotrolContext)) {
      const convertModuleIdToArray = value.split('_');

      return VitotrolName[convertModuleIdToArray[1] + '_' + convertModuleIdToArray[2]];
    } else {
      return value;
    }
  }
}
